import platformConfigReducer from './reducers';

export default platformConfigReducer;
